<template>
  <div class="seized-properties" v-if="!['partner', 'agent'].includes($store.state.me.role)">
    <div class="main__header">
      <div class="main__header__item left"></div>
      <div class="main__header__item left">
        <h1>Изъятое имущество</h1>
      </div>
      <div class="main__header__item right"></div>
    </div>
    <div v-if="error" class="messages__status error" style="width: auto; margin: 0 20px">{{ error }}</div>
    <div v-else class="main__content lk">
      <div class="seized-properties__container">
        <div class="seized-properties__list">
          <div
            class="seized-properties__elem"
            v-for="(elem, index) in data"
            :key="index"
          >
            <div class="seized-properties__images" :ref="`seized-properties__images--${index}`">
              <img
                class="seized-properties__image"
                :src="`${baseURL}/api/seized-property/image?dir=${elem.title}&filename=${image}`"
                :alt="image"
                v-for="image in elem.images"
                :key="image"
              />
            </div>
            <button class="seized-properties__left" @click="onScrollRoute(`seized-properties__images--${index}`, 'left')">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12-5.373-12-12-12-12 5.373-12 12zm7.58 0l5.988-5.995 1.414 1.416-4.574 4.579 4.574 4.59-1.414 1.416-5.988-6.006z" />
              </svg>
            </button>
            <button class="seized-properties__right" @click="onScrollRoute(`seized-properties__images--${index}`, 'right')">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.568 18.005l-1.414-1.415 4.574-4.59-4.574-4.579 1.414-1.416 5.988 5.995-5.988 6.005z" />
              </svg>
            </button>
            <div
              class="seized-properties__content"
              @click="selectElem(elem)"
            >
              {{ getName(elem) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SeizedProperties',
  data () {
    return {
      baseURL: process.env.VUE_APP_HTTP,
      data: [],
      selectedElem: null,
      error: null
    }
  },
  async created () {
    await this.getData()
  },
  methods: {
    getName (elem) {
      if (elem) {
        const info = {}
        Object.keys(elem.info).forEach(key => {
          info[key.trim()] = elem.info[key]
        })
        if (info && info['Наименование']) return info['Наименование']
        else if (elem.contract && elem.contract.property_name) return elem.contract.property_name
      } else return 'Без наименования'
    },
    closeModal () {
      this.selectedElem = null
    },
    selectElem (elem) {
      this.selectedElem = elem
      this.$router.push({ params: { hash: elem.hash }, name: 'seized-properties-selected' })
    },
    onScrollRoute (refName, route) {
      const el = this.$refs[refName][0]
      const width = el.clientWidth

      el.scrollBy({
        left: route === 'left' ? -width : width,
        behavior: 'smooth'
      })
    },
    async getData () {
      const response = await axios.get(`${this.baseURL}/api/seized-property/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('apollo-token')}`
        }
      })
        .catch(() => {
          this.error = 'Не удалось получить данные'
        })
      this.data = response.data.map(elem => ({
        ...elem,
        info: { ...elem.info }
      }))
      // const response2 = await axios.get(`${this.baseURL}/api/seized-property/dir?hash=${response.data[0].hash}`)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .seized-properties
    &__container
      display flex
      min-height calc(100vh - 300px)
      width 100%

    &__list
      width 100%
      display grid
      grid-template-columns repeat(auto-fit, 200px)
      grid-gap 16px

      padding 15px

    &__elem
      height 240px
      width 100%
      // border 1px solid $black
      border-radius 15px

      display grid
      grid-template-rows 2fr 1fr

      position relative
      overflow hidden

      &:hover
        box-shadow: rgba(33,37,41,0.2) 0 20px 40px

    &__images
      display flex
      flex-direction row
      width 100%
      height 100%
      overflow hidden

    &__image
      height 100%
      min-width 100%
      max-width 100%
      object-fit: cover
      object-position: center

    &__content
      background-color $dark
      // opacity .6
      border-bottom-right-radius 15px
      border-bottom-left-radius 15px
      color $gray
      padding 10px
      cursor pointer

      display flex
      align-items center

    &__left,
    &__right
      position absolute
      left 10px
      top 35%
      transform translate(-50%, -50%)
      border none
      padding 0
      border-radius 100%

    &__right
      left unset
      right 10px
      transform translate(50%, -50%)

    &__left svg,
    &__right svg
      display block
      width 12px
      height 12px
      cursor pointer

      path
        fill $dark

.seized-properties-modal
  &__images
    height 100%
    max-height 90vh
    width 100%
    max-width 800px

</style>
